exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing[data-v-4ea6aa4a]{position:relative;width:100%;height:100%;background-color:#3c515b;background-repeat:no-repeat;background-size:100%;margin:0 auto;padding:0}.listing__title[data-v-4ea6aa4a]{position:absolute;bottom:0;left:0;width:100%;color:#fff;z-index:1;padding:80px 40px 40px;background:linear-gradient(180deg,transparent,#000);font-weight:500}.listing__title b[data-v-4ea6aa4a]{font-weight:600;display:block;font-style:inherit;margin:0 0 10px}.listing__title i[data-v-4ea6aa4a]{margin:10px 0 0;display:block;font-size:20px;font-style:inherit;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ea6aa4a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Listing.vue
// module id = 50
// module chunks = 0